import 'components/Public/style.css'

import React from 'react'
import { compose, withState } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { makesQueries, dataFetched } from 'data/graphql'
import { selectors as ConfigSelectors } from 'data/config'
import { getNote, getAllNotes } from 'data/publicNotes/selectors'
import { getActiveNoteId } from 'data/publicUI/selectors'

import * as URLHelper from 'helpers/URLHelper'
import { listJoinedOrganizations } from 'helpers/OrganizationsHelpers'

import NotFound from 'components/Errors/Channel/PublicChannelNotFound'

import OrganizationsAPI from 'remote/organizations'

import providesPublicPagesABFlags from 'components/Public/datasync/providesPublicPagesABFlags'

import ChannelLoading from './ChannelLoading'
import StructurePanel from './StructurePanel'
import NotePanel from './NotePanel'
import Header from 'components/Public/Header'
import { ChannelContainerLayout } from 'components/Public/Layout'
import PromotionalModal from 'components/Public/PromotionalModal'

import { showPublicChannel } from 'components/CloneChannel/dataSync'

class PublicChannel extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
  }

  state = {}

  componentDidMount() {
    // Ensure Intercom doesn't load
    window.Intercom && window.Intercom('hide')

    this.fetchOrganization(this.props)
  }

  // Load organization public content
  fetchOrganization = ({ apiEndpoint, joinedOrganizationIds }) => {
    const organizationDomain = URLHelper.getOrganizationDomain()
    OrganizationsAPI.fetchOrganizationPublicInfoWithDomain(
      { apiEndpoint },
      organizationDomain
    ).then(
      organizationResponse => {
        const organizationData = organizationResponse.included[0].attributes
        this.setState({
          organizationPhotoURL: organizationData.photoURL,
          organizationName: organizationData.name,
          organizationDomain: organizationData.domain,
          freePlan: organizationData.displayPromotionalBanner, // TODO change the field name api-side
          alreadyJoined: joinedOrganizationIds.includes(
            organizationResponse.included[0].id
          ),
          alreadyUser: joinedOrganizationIds.length > 0, // Check if visitor is a member of a Slite org
          error: null,
        })
      },
      error => {
        this.setState({ error })
      }
    )
  }

  render() {
    const { publicChannel, error, note, activeNoteId } = this.props
    const {
      freePlan,
      organizationPhotoURL,
      organizationName,
      alreadyJoined,
      alreadyUser,
    } = this.state
    if (error) {
      return <NotFound />
    }
    return (
      <ChannelContainerLayout
        className={activeNoteId && 'public-channel-active-note'}
      >
        <Helmet
          meta={[
            {
              name: 'viewport',
              content: 'width=device-width,user-scalable=no',
            },
          ]}
        />
        {publicChannel && (
          <Header
            freePlan={freePlan}
            channelId={publicChannel.id}
            organizationPhotoURL={organizationPhotoURL}
            organizationName={organizationName}
            alreadyJoined={alreadyJoined}
          />
        )}
        {publicChannel ? (
          <React.Fragment>
            <StructurePanel publicChannel={publicChannel} />
            <NotePanel publicChannelId={publicChannel.id} note={note} />
          </React.Fragment>
        ) : (
          <ChannelLoading />
        )}
        {freePlan && !alreadyUser && <PromotionalModal origin="channel" />}
      </ChannelContainerLayout>
    )
  }
}

const mapStateToProps = state => {
  const activeNoteId = getActiveNoteId(state)
  return {
    apiEndpoint: ConfigSelectors.getApiEndpoint(state),
    joinedOrganizationIds: listJoinedOrganizations(),
    activeNoteId,
    note: activeNoteId
      ? getNote(state, activeNoteId)
      : getAllNotes(state)
          .sort((a, b) => b.get('listPosition') - a.get('listPosition'))
          .first(),
  }
}

export default compose(
  providesPublicPagesABFlags,
  connect(
    mapStateToProps,
    {
      dataFetched,
    }
  ),
  withState('publicChannel', 'setPublicChannel', null),
  withState('error', 'setError', null),
  makesQueries({
    query: showPublicChannel,
    mapPropsToVariables: ({ token }) => ({ publicShareToken: token }),
    getOnResultFromProps: ({ dataFetched, setPublicChannel }) => ({
      result,
    }) => {
      dataFetched(result.data.showPublicChannel)
      setPublicChannel(result.data.showPublicChannel)
    },
    getOnErrorFromProps: ({ setError }) => ({ error }) => {
      setError(error)
    },
  })
)(PublicChannel)
